import { LoadingButton } from "@mui/lab";
import { Alert, Box,TextField, Typography } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import { useFormik } from "formik";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { distributorStockTransactionThunk } from "store/reducers/inventory/stock/distributorStockSlice";
import * as yup from "yup";

const ReturnDistributorStock = ({ open, handleClose, stock }) => {
  const dispatch = useDispatch();
  const validation = yup.object({
    qty: yup.number().required().positive().min(1).max(stock.qty),
  });
  const formik = useFormik({
    initialValues: {
      qty: stock.qty,
      product_variant: stock.product_variant,
      in_or_out: "ret",
    },
    validationSchema: validation,
    onSubmit: (data) => {
      //   console.log(data);
      dispatch(distributorStockTransactionThunk({stock,data}));
    },
    enableReinitialize: true,
  });
  const state = useSelector(
    (state) => state.distributorStock.distributorStockTransactionStatus
  );
  return (
    <CustomDialog
      forceFullScreen={false}
      open={open}
      handleClose={handleClose}
      heading="Return stock"
    >
      <Box padding={2}>
        <Typography variant="h6" color="text.secondary">
          You are about to return the following product
        </Typography>
        <Typography variant="h5" color="text.secondary">
          {stock.name}
        </Typography>
        <form onSubmit={formik.handleSubmit} style={{ marginTop: 2 }}>
          <TextField
            fullWidth
            name="qty"
            value={formik.values.qty}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.qty)}
            helperText={formik.errors.qty}
            type="number"
          />
          {state?.error === "get" && (
            <Alert sx={{ my: 1 }} severity="error">
              Error occurred , {state?.errorMessage}
            </Alert>
          )}

          {state?.success === "get" && (
            <Alert sx={{ my: 1 }} severity="success">
              Success
            </Alert>
          )}
          <LoadingButton
            sx={{ mt: 2 }}
            variant="outlined"
            type="submit"
            loading={state?.loading === "get"}
          >
            Submit
          </LoadingButton>
        </form>
      </Box>
    </CustomDialog>
  );
};

export default ReturnDistributorStock;
